import React from "react";
import { component_tool } from "@/tool";
const { WizRow, WizCol, WizInputNumber, WizTooltip, WizIcon, WizCard } = component_tool;
import { WizTableForm } from '@/containers/common'
import ContentType from "./ContentType";
import ApplyNotice from "../applyNotice/applyNotice"
// import ExamCategorySelect from "../../exam/examCategorySelect/examCategorySelect";
// import EditTable from "./EditTable";

export default (self, other, record) => {
  return [
    {

      title: '业务类型',
      name: 'bizType',
      dataIndex: 'bizType',
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 15, codeName: '报名' },
        { code: 26, codeName: '直播' },
        { code: 30, codeName: '作业' },
        { code: 38, codeName: "任务" },
        { code: 12, codeName: '路径必修' },
        { code: 39, codeName: '路径' },
        { code: 2, codeName: '问卷' },
        { code: 36, codeName: '班级' },
      ],

      formItem: {
        type: 'select',
        initialValue: record ? record['bizType'] : null,
        rules: [{ required: true, message: '请选择业务类型' }],
      },
    },
    // {
    //     title: '关联业务',
    //     name: 'id',
    //     formItem: {
    //         type: "diy",
    //         config:other,
    //         bizName:record?record['bizName']:null,
    //         initialValue:record?record['id']:null,
    //         modal: true,
    //         diy: ContentType,
    //         rules: [
    //           { validator: ContentType.validator }
    //         ]
    //       },
    // },
    // {
    //   title: "考试分类",
    //   name: "categoryTypeId",
    //   formItem: {
    //     type: "diy",
    //     selects: other.selects,
    //     diy: ExamCategorySelect,
    //     rules: [{ required: true, message: "请选择考试分类" }],
    //   }
    // },

    {
      title: "通知渠道",
      name: 'noticeInfo',
      formItem: {
        type: "diy",
        bizType: record ? record['bizType'] : null,
        contentType: record ? record['contentType'] : null,
        modal: true,
        diy: ApplyNotice,
        links: 'bizType',
        rules: [
          // { validator: ApplyNotice.validator }
        ]
      },
    },
    // {
    //   title: "关联考试模版",
    //   name: "examTemplateAuthInfo",
    //   formItem: {
    //     type: "diy",
    //     modal: true,
    //     diy: EditTable,
    //     rules: [
    //       { validator: EditTable.validator }
    //     ]
    //   },
    // },
    // {
    //   title: "状态",
    //   name: "status",
    //   dict: [
    //     {
    //       code: 1,
    //       codeName: "有效",
    //     },
    //     {
    //       code: 0,
    //       codeName: "无效",
    //     },
    //   ],
    //   formItem: {
    //     type: "radio"
    //   }
    // },
  ];
};
